import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API } from '../api'

// 获取faq列表
export const getFaqList = createAsyncThunk('user/getFaqList', async (params, thunkAPI) => {
  const response = await API.getFaqList(params)
  return response.data
})
// 获取faq类型
export const getFaqTypeList = createAsyncThunk('user/getFaqTypeList', async (params, thunkAPI) => {
  const response = await API.getFaqTypeList(params)
  return response.data
})
export const docSlice = createSlice({
  name: 'doc',
  initialState: {
    faqList: [],
    faqTypeList: [],
    faqListTypeStatus: '',
    faqListStatus: '',
  },
  reducers: {},
  // reducers 支持两种不同的形式
  // 1、builder callback
  // 2、map object
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    // 获取faq列表
    builder.addCase(getFaqList.pending, (state, action) => {
      state.faqListStatus = 'pending'
    })
    builder.addCase(getFaqList.fulfilled, (state, action) => {
      state.faqListStatus = 'fulfilled'
      state.faqList = action?.payload?.filter((item) => item?.status) || []
    })
    builder.addCase(getFaqList.rejected, (state, action) => {
      state.faqListStatus = 'rejected'
    })

    // 获取faq类型列表
    builder.addCase(getFaqTypeList.pending, (state, action) => {
      state.faqListTypeStatus = 'pending'
    })
    builder.addCase(getFaqTypeList.fulfilled, (state, action) => {
      state.faqListTypeStatus = 'fulfilled'
      state.faqTypeList = action.payload
    })
    builder.addCase(getFaqTypeList.rejected, (state, action) => {
      state.faqListTypeStatus = 'rejected'
    })
  },
})

// Action creators are generated for each case reducer function
// export const {} = userSlice.actions

export default docSlice.reducer
